import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { SectorType } from './sector-type.interface';
import { SectorTypeService } from './sector-type.service';

const service = new SectorTypeService();

export interface SectorTypeState {
   sectorTypes: Array<SectorType>;
}

const SectorTypeStore: Module<SectorTypeState, StoreState> = {
   namespaced: true,
   state: { sectorTypes: [] },
   getters: {
      sectorTypes: (state) => state.sectorTypes,
   },
   mutations: {
      SET_SECTOR_TYPES(state, sectorTypes: Array<SectorType>) {
         state.sectorTypes = sectorTypes;
      },
   },
   actions: {
      async getSectorTypes(context, query?: LocationQuery) {
         const response = await service.getSectorTypes(query);
         context.commit('SET_SECTOR_TYPES', response.data);
         return response;
      },
   },
};

export default SectorTypeStore;
